import AOS from "aos";
import "aos/dist/aos.css";
import blogData from "../constants/index";
import { useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useParams } from "react-router-dom";
import aboutbackgroundText from "../assets/images/aboutbackgroundText.webp";

export default function BlogDetail() {
	const { id } = useParams();
	const [blog, setBlog] = useState(null);

	useEffect(() => {
		const selectedBlog = blogData.find((b) => b.id === id);
		setBlog(selectedBlog || null);

		AOS.init({ duration: 2000 });
		window.scrollTo(0, 0);

		if (selectedBlog) {
			document.title = selectedBlog.title;
			document
				.getElementById("meta-description")
				.setAttribute("content", selectedBlog.content[0]);
		}
	}, [id]);

	if (!blog) {
		return (
			<div style={{ padding: "40px", textAlign: "center" }}>
				<h2>Blog not found</h2>
				<Button
					component={Link}
					to="/blogs"
					startIcon={<FaArrowLeftLong />}>
					Back to Blogs
				</Button>
			</div>
		);
	}

	return (
		<Grid>
			{/* Banner */}
			<div className="innerban">
				<div className="contact-bannerText">
					<img
						src={aboutbackgroundText}
						alt="Banner background"
						className="product-bannerText-Img"
					/>
					<h1
						className="contact-heading"
						data-aos="fade-up">
						Blog Detail
					</h1>
				</div>
			</div>

			{/* Blog Detail Content */}
			<section
				style={{ padding: "40px 20px", maxWidth: "900px", margin: "0 auto" }}>
				<Button
					component={Link}
					to="/blogs"
					startIcon={<FaArrowLeftLong />}
					style={{ marginBottom: "20px", textTransform: "none" }}>
					Back to Blogs
				</Button>

				<h2 style={{ fontSize: "2rem", marginBottom: "10px" }}>{blog.title}</h2>
				<p style={{ color: "#666", marginBottom: "30px" }}>{blog.date}</p>

				<img
					src={blog.image}
					alt={blog.title}
					style={{
						width: "100%",
						height: "auto",
						borderRadius: "8px",
						marginBottom: "30px",
						objectFit: "cover",
					}}
				/>

				{blog.content.map((paragraph, index) => (
					<p
						key={index}
						style={{
							fontSize: "1rem",
							lineHeight: "1.7",
							marginBottom: "20px",
							color: "#333",
						}}>
						{paragraph}
					</p>
				))}
			</section>
		</Grid>
	);
}
